import { styled, css } from '@mui/material'
import {
  LazyLoadImage,
  LazyLoadImageProps
} from 'react-lazy-load-image-component'
import { LogoStylesProps } from './Logo.types'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import { getUnitValue } from '../../../utils/processStyles'

export const LogoStyled = styled(LazyLoadImage, {
  name: 'Logo',
  shouldForwardProp: (prop) => !['radius', 'height'].includes(String(prop))
})<LazyLoadImageProps & LogoStylesProps>(
  ({ size, radius }) => css`
    display: block;
    object-fit: contain;
    width: auto;
    max-width: 100%;
    height: ${getUnitValue(size)};
    border-radius: ${getUnitValue(radius)};
  `
)
LogoStyled.defaultProps = {
  radius: 4,
  size: '36px',
  effect: 'opacity'
}

export default LogoStyled
